import { render } from "./Entry.vue?vue&type=template&id=2dc47b60&scoped=true"
import script from "./Entry.vue?vue&type=script&lang=js"
export * from "./Entry.vue?vue&type=script&lang=js"

import "./Entry.vue?vue&type=style&index=0&id=2dc47b60&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc47b60"]])

export default __exports__